var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nanoid } from 'nanoid';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class BrowserTab {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get tabId() {
        /* https://stackoverflow.com/questions/11896160/any-way-to-identify-browser-tab-in-javascript
           * UPDATE:
        In some cases, you may have same sessionStorage in multiple tab (e.g. when you duplicate tab). In that case, following code may helps:
           * */
        const tabId = sessionStorage.appId && sessionStorage.closedLastTab !== '2' ? sessionStorage.appId : (sessionStorage.appId = nanoid(8));
        sessionStorage.closedLastTab = '2';
        window.addEventListener('beforeunload', event => {
            sessionStorage.closedLastTab = '1';
        });
        return tabId;
    }
}
__decorate([
    memoize
], BrowserTab.prototype, "tabId", null);
